module.exports = __webpack_public_path__ + "img/80018.4fc02f8c.png";